<template>
    <div>
        <header-portrate />


    <div class="pa-2 m-2">
        
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row :style="`margin-top:0;direction:`+lang.dir+`;padding-left:30px;padding-right:30xp;`">
            <v-col cols="12" class="text-end">
                <b-button id="multiply-button" :class="`mt-10 multiply-button-`+lang.lalgin" 
                :style="`width:150px;background:transparent;border:none`" 
                @click="resetfixed()"
                v-b-toggle.add_fixed_assets>
              <div style="width:150px;color:#000" :class="`multiply-button-content-`+lang.lalgin"> اصل ثابت</div></b-button>
            </v-col>
        </v-row>
        <v-simple-table style="padding-left:30px;padding-right:30xp;">
            <thead>
                <tr>
                    <th class="text-center">القسم</th>
                    <th class="text-center">الاصل الثابت</th>
                    <th class="text-center">تاريخ الشراء</th>
                    <th class="text-center">سعر الشراء</th>
                    <th class="text-center">مدة الاهلاك</th>
                    <th class="text-center">العدد</th>
                    <th class="text-center">الاجمالي</th>
                    <th class="text-center">نسبة الاهلاك</th>
                    <th class="text-center">قيمة الاهلاك</th>
                    <th class="text-center">القيمة الحالية</th>
                    <th class="text-center">الاجراء</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in paytypesrows" :key="index">
                    <td>{{item.group_name}}</td>
                    <td>{{item.namear}}</td>
                    <td>{{item.purchase_date}}</td>
                    <td>{{item.pprice}}</td>
                    <td>{{item.yers}}</td>
                    <td>{{item.qtty}}</td>
                    <td>{{item.total}}</td>
                    <td>{{item.dep_percentage}}</td>
                    <td>{{item.depamount}}</td>
                    <td>{{item.current}}</td>
                    <td style="width:100px;background:#000;border-bottom:1px solid #fff !important;padding:1px">
                        <b-button class="btn-sm btn-default" style="color:#FFF;background:#000;width:100px;height:25px !important;margin-left:5px;border:none" @click="edit(item)" v-b-toggle.add_fixed_assets>{{lang.update}} &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></b-button>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <add-fixed-asstes ref="myfixedassets" />
    </div>
        <Footer />
    </div>
</template>

<script>
import breadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import AddFixedAsstes from '@/components/addFixedAsstes.vue';
export default {
    components: { breadCrumbs, TabsComp, HeaderPortrate,Footer, AddFixedAsstes },
    data() {
        return {
            paytypesrows:[]
        }
    },
    created() {
        this.getFixedAsstes();
    },
    methods: {
        resetfixed(){
            this.$refs.myfixedassets.restAll();
        },
        edit(item){
            this.$refs.myfixedassets.fillit(item);
        },
        getFixedAsstes(){
            const post = new FormData();
            post.append('type','getFixed');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // console.log(res);
                this.paytypesrows = res.results.data;
                
            })
        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        tabs: function(){
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });
        
            let t = []
            Object.values(cMenu).forEach(value =>{
            
                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }
            
            })
        
            return t;
        },
        items: function() {
            return {
                    text: this.lang.paytypes,
                    disabled: true,
                    to: '/finance/paytypes',
                }
        },
       
    },
}
</script>